export default {
    methods: {
      _disconnectSocketLotto(){
        if(this.$socket){
          this.$socket.disconnect()
          this.$socket.removeAllListeners()
        }
      },
      _connectSocketLotto(){
        if(this.$socket){
          this.$socket.disconnect()
          this.$socket.removeAllListeners()
        }
        this.$connectSocket();
        this.listenerSocketLotto()
      },
      listenerSocketLotto() {
        this.$globalSocket.on("client-status-channel-type", (data) => {
          // console.log(`socket on client-update-channel-info: ${JSON.stringify(data)}`);
          if (data) {
            this.UPDATE_CHANNEL_STATUS(data);
          }
        });
        this.$globalSocket.on("client-update-user-info", (data) => {
          if (data) {
            if (data.is_suspend) {
              this.$toastr.e(`Your account have been blooked!`)
              this.onLogout()
            }
            // data.channel_list = this.channelList;
            // this.updateUserInfo(data);
            this.updateBalance(data.balance);
          }
        });
        // socket get random number, total number,
        this.$socket.on("client-random", (data) => {
          if (data && data.total != null) {
            let interval;
            const _this = this;
            interval = setInterval(function () {
              let result = parseInt(Math.random() * (80 - 1) + 1);
              _this.randomNumber = result;
            }, 50);
            setTimeout(() => {
              clearInterval(interval);
              _this.randomNumber = null;
              _this.clientRandom = data;
              _this._playSoundBang();
              if(this.$confetti) this.$confetti.stop;
            }, 800);
          }
        });
        // socket get time,  is betting, is coldown
        this.$socket.on("client-time", (data) => {
          if (data) {
            // define client time to display count down time at play zone
            this.clientTime = data;
            // play audio sound
            if (data.time == 59) {
              this._playSoundBetDown();
            }
            if (data.time < 11 && data.time != 0) this._playSoundTing();
            if (data.time == 0) this._playSoundGoodLuck();
          }
        });
        // get new game
        this.$socket.on("client-new-game", (data) => {
          if (data) {
            this.clientRandom = [];
            this.bonus = [];
            // this._clearResult();
            this._initialData();
          }
        });
        // get game result and bonus
        this.$socket.on("client-result", (data) => {
          if (data) {
            this.clientResult = data;
          }
        });
        this.$socket.on("client-bonus", (data) => {
          if (data) {
            this.bonus = data;
            if (this.bonus.is_bonus) {
              this.$confetti.start();
              this._playSoundCongratulation();
            }
          }
        });
      },
    }
}